import classnames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';

import { CheckmarkListProps, CheckmarksDisplayProps, CheckmarkType } from './CheckmarkTypes';

import './CheckmarkList.scss';

const Checkmark = ({ label, checked, unavailable = false }: CheckmarkType): JSX.Element => (
    <li className="sgw-checkmark-list__checkmark-item">
        <div
            className={classnames('sgw-checkmark-list__icon', {
                'sgw-checkmark-list__icon--unchecked': !checked,
                'sgw-checkmark-list__icon--unavailable': unavailable,
            })}
        >
            <Icon type={checked ? IconTypes.CHECKMARK_TIL_SIRKEL_24 : IconTypes.KRYSS_24} />
        </div>
        <p>{label}</p>
    </li>
);

const CheckMarksDisplay = ({ checkmarks }: CheckmarksDisplayProps) => (
    <>
        {checkmarks.map(({ key, label, checked, unavailable }) => (
            <Checkmark key={key ?? label} label={label} checked={checked} unavailable={unavailable} />
        ))}
    </>
);

const isChecked = ({ checked }: CheckmarkType): boolean => checked;

const CheckmarkList = ({ checkmarks, uncheckedListLabel = 'Dekkes ikke' }: CheckmarkListProps): JSX.Element => {
    const checkedCheckmarks = checkmarks.filter(isChecked);
    const uncheckedCheckmarks = checkmarks.filter((checkmark) => !isChecked(checkmark));

    return (
        <ul className="sgw-checkmark-list">
            <CheckMarksDisplay checkmarks={checkedCheckmarks} />

            {uncheckedCheckmarks.length > 0 && (
                <>
                    <div className="sgw-checkmark-list__unchecked-list-label">{uncheckedListLabel}</div>
                    <CheckMarksDisplay checkmarks={uncheckedCheckmarks} />
                </>
            )}
        </ul>
    );
};

export default CheckmarkList;
